import {  createSlice,  createAsyncThunk } from "@reduxjs/toolkit";
import { refreshAccessToken } from "../Authorization/authSlice";
import Config from '../../config/config';
const serverPath = Config.serverPath;

export const getAllUsers = createAsyncThunk(
    "user/getAllUsers", async(id, thunkApi) => {
         const {dispatch} = thunkApi;

        const url = serverPath + "/api/users/";

        const urlToFetch = `${url}`;
        const response = await fetch(urlToFetch, {
            method: 'GET',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`
            },
           
            credentials: 'include',
            mode: 'cors',
        });
        console.log("RESPONSE" + response.ok);
        if (response.ok) {
            const answer = await response.json();
           
            console.log("Успех getData" + answer + JSON.stringify(answer));
            return answer;
        } else if (response.status === 401) {
                  
                    console.log('401 -refresh access token!');
                    try {
                        const result = await dispatch(refreshAccessToken());
                      //IF ACCESS AND REFRESH TOKEN BAD
                        console.log(result.payload);
                        if (result.payload) {
                          dispatch(getAllUsers());
                        } else {
                            console.log('Bad refresh access');
                        }
                    } catch (e) {
                        console.log('Error');
                    } 
                }  else {
         
           console.log('getData' + response.status);
         return response.status;
         }
        }
    
);


const initialState = {
    
    data:[],
    errorMessage:'',
    userMessage: ''   
}

const options ={
    name: 'user',
    initialState: {
        
        data:[],
        errorMessage:'',
        userMessage: ''
    },
    reducers: {
        getInitialStateData: state =>
        initialState,
    },
    extraReducers(builder) {
        builder
        .addCase(getAllUsers.pending, (state, action) => {
            state.isFetching = true;
            state.error = false;
            state.userMessage = 'Загрузка...';
        })
        .addCase(getAllUsers.fulfilled, (state, action) => {
            if (action.payload === 401) {
                
                state.userMessage = ' NO AUTH!';
                state.data = [];

                
             } else {
                console.log(action.payload);
                state.isFetching = true;
                state.data = action.payload;

             }

           
        })
        .addCase(getAllUsers.rejected, (state, action) => {

            state.isFetching = false;
            state.error = action.payload;
            state.errorMessage = 'not get users something wrong!';
            state.userMessage = 'Загружено';
        })

    }

};
export const userSlice = createSlice(options);
export const {getInitialStateData} = userSlice.actions;
export default userSlice.reducer;
